






import { Component, Vue } from "vue-property-decorator";
import HhAuditList from "@/components/ppi/hh-audit/HhAuditList.vue";

@Component({
  components: { HhAuditList }
})
export default class HhFasilitasAuditPage extends Vue {}
